<template>
    <div class="w-100">
        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>
            </div>
            <!-- Progress bar -->
            <div v-if="progressBar == true" class="col-3 ms-auto d-print-none d-flex align-items-center" id="progressBar">
                <span class="small me-3 w-50 text-end">{{ percentageComplete }}% Complete</span>
                <b-progress class="w-50" :value="currentStep" :max="maxStep" animated></b-progress>
            </div>
        </div>

        <!-- Alert box -->
        <div v-if="this.v$.step[this.currentStep - 1].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep - 1].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep - 1].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-care-plan" action="care-plans/store" class="add-care-plan add-record">
            
            <div class="card" v-if="currentStep == 1" title="Introduction">
                <div class="card-header">
                    <h3 class="card-title">Introduction</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Overall introduction to the resident </div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Overall introduction to the resident"
                                    value=""
                                    spellcheck="false"
                                    name="overallIntroduction"
                                    v-model="step[0].overallIntroduction"
                                    :class="{
                                        'is-invalid': v$.step[0].overallIntroduction.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].overallIntroduction.$invalid}">Invalid feedback</div>
                            </div>

                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Medical Diagnosis</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="medicalDiagnosisNeed"
                                    v-model="step[0].medicalDiagnosisNeed"
                                    :class="{
                                        'is-invalid': v$.step[0].medicalDiagnosisNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].medicalDiagnosisNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="medicalDiagnosisGoalAim"
                                    v-model="step[0].medicalDiagnosisGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[0].medicalDiagnosisGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].medicalDiagnosisGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="medicalDiagnosisStaffIntervention"
                                    v-model="step[0].medicalDiagnosisStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[0].medicalDiagnosisStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].medicalDiagnosisStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Relative Notifications</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="relativesNotificationsNeed"
                                    v-model="step[0].relativesNotificationsNeed"
                                    :class="{
                                        'is-invalid': v$.step[0].relativesNotificationsNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].relativesNotificationsNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <!-- <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="relativesNotificationsGoalAim"
                                    v-model="step[0].relativesNotificationsGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[0].relativesNotificationsGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].relativesNotificationsGoalAim.$invalid}">Invalid feedback</div>
                            </div> -->
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <!-- <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="relativesNotificationsStaffIntervention"
                                    v-model="step[0].relativesNotificationsStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[0].relativesNotificationsStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].relativesNotificationsStaffIntervention.$invalid}">Invalid feedback</div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn d-none">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 2" title="Activity">
                <div class="card-header">
                    <h3 class="card-title">Activity</h3>
                </div>
                <div class="card-body">                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Physical Activities</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="physicalActivitiesNeed"
                                    v-model="step[1].physicalActivitiesNeed"
                                    :class="{
                                        'is-invalid': v$.step[1].physicalActivitiesNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].physicalActivitiesNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="physicalActivitiesGoalAim"
                                    v-model="step[1].physicalActivitiesGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[1].physicalActivitiesGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].physicalActivitiesGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="physicalActivitiesStaffIntervention"
                                    v-model="step[1].physicalActivitiesStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[1].physicalActivitiesStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].physicalActivitiesStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Mobility / Transfer Aids needed</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="mobilityAidsNeed"
                                    v-model="step[1].mobilityAidsNeed"
                                    :class="{
                                        'is-invalid': v$.step[1].mobilityAidsNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].mobilityAidsNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="mobilityAidsGoalAim"
                                    v-model="step[1].mobilityAidsGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[1].mobilityAidsGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].mobilityAidsGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="mobilityAidsStaffIntervention"
                                    v-model="step[1].mobilityAidsStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[1].mobilityAidsStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].mobilityAidsStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Functional status ADL self-performance</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="functionalStatusNeed"
                                    v-model="step[1].functionalStatusNeed"
                                    :class="{
                                        'is-invalid': v$.step[1].functionalStatusNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].functionalStatusNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="functionalStatusGoalAim"
                                    v-model="step[1].functionalStatusGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[1].functionalStatusGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].functionalStatusGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="functionalStatusStaffIntervention"
                                    v-model="step[1].functionalStatusStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[1].functionalStatusStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].functionalStatusStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>
            
            <div class="card" v-if="currentStep == 3" title="Physical">
                <div class="card-header">
                    <h3 class="card-title">Physical</h3>
                </div>
                <div class="card-body">                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Showering and washing including hair wash</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="showeringWashingNeed"
                                    v-model="step[2].showeringWashingNeed"
                                    :class="{
                                        'is-invalid': v$.step[2].showeringWashingNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[2].showeringWashingNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="showeringWashingGoalAim"
                                    v-model="step[2].showeringWashingGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[2].showeringWashingGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[2].showeringWashingGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="showeringWashingStaffIntervention"
                                    v-model="step[2].showeringWashingStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[2].showeringWashingStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[2].showeringWashingStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Grooming/ Dressing Including need for make-up, shaving</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="groomingDressingNeed"
                                    v-model="step[2].groomingDressingNeed"
                                    :class="{
                                        'is-invalid': v$.step[2].groomingDressingNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[2].groomingDressingNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="groomingDressingGoalAim"
                                    v-model="step[2].groomingDressingGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[2].groomingDressingGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[2].groomingDressingGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="groomingDressingStaffIntervention"
                                    v-model="step[2].groomingDressingStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[2].groomingDressingStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[2].groomingDressingStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Restraint or enabler requirement (complete Restraint assessment)</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="restraintRequirementNeed"
                                    v-model="step[2].restraintRequirementNeed"
                                    :class="{
                                        'is-invalid': v$.step[2].restraintRequirementNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[2].restraintRequirementNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="restraintRequirementGoalAim"
                                    v-model="step[2].restraintRequirementGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[2].restraintRequirementGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[2].restraintRequirementGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="restraintRequirementStaffIntervention"
                                    v-model="step[2].restraintRequirementStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[2].restraintRequirementStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[2].restraintRequirementStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 4" title="Cognitive">
                <div class="card-header">
                    <h3 class="card-title">Cognitive</h3>
                </div>
                <div class="card-body">                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Cognitive Patterns / Skills for daily decision making</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="cognitivePatternsNeed"
                                    v-model="step[3].cognitivePatternsNeed"
                                    :class="{
                                        'is-invalid': v$.step[3].cognitivePatternsNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].cognitivePatternsNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="cognitivePatternsGoalAim"
                                    v-model="step[3].cognitivePatternsGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[3].cognitivePatternsGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].cognitivePatternsGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp; </div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="cognitivePatternsStaffIntervention"
                                    v-model="step[3].cognitivePatternsStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[3].cognitivePatternsStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].cognitivePatternsStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Memory/Recall Ability / Long-term and short-term memory</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="memoryRecallNeed"
                                    v-model="step[3].memoryRecallNeed"
                                    :class="{
                                        'is-invalid': v$.step[3].memoryRecallNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].memoryRecallNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="memoryRecallGoalAim"
                                    v-model="step[3].memoryRecallGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[3].memoryRecallGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].memoryRecallGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="memoryRecallStaffIntervention"
                                    v-model="step[3].memoryRecallStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[3].memoryRecallStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].memoryRecallStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Communication / Vision & Hearing / Making self understood, ability to understand others /  Any aids used (hearing aids, glasses)</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="communicationVisionNeed"
                                    v-model="step[3].communicationVisionNeed"
                                    :class="{
                                        'is-invalid': v$.step[3].communicationVisionNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].communicationVisionNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="communicationVisionGoalAim"
                                    v-model="step[3].communicationVisionGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[3].communicationVisionGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].communicationVisionGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label mt-3">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="communicationVisionStaffIntervention"
                                    v-model="step[3].communicationVisionStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[3].communicationVisionStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[3].communicationVisionStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 5" title="Behaviour">
                <div class="card-header">
                    <h3 class="card-title">Behaviour</h3>
                </div>
                <div class="card-body">                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Mood/Behaviour / Depression, anxiety / Behaviour symptoms / Behavioural Chart Yes/No</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="moodBehaviourNeed"
                                    v-model="step[4].moodBehaviourNeed"
                                    :class="{
                                        'is-invalid': v$.step[4].moodBehaviourNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[4].moodBehaviourNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="moodBehaviourGoalAim"
                                    v-model="step[4].moodBehaviourGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[4].moodBehaviourGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[4].moodBehaviourGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label mt-3">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="moodBehaviourStaffIntervention"
                                    v-model="step[4].moodBehaviourStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[4].moodBehaviourStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[4].moodBehaviourStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Psychosocial well-being / Social relationship / Sense of involvement</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="phychosocialWellbeingNeed"
                                    v-model="step[4].phychosocialWellbeingNeed"
                                    :class="{
                                        'is-invalid': v$.step[4].phychosocialWellbeingNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[4].phychosocialWellbeingNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="phychosocialWellbeingGoalAim"
                                    v-model="step[4].phychosocialWellbeingGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[4].phychosocialWellbeingGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[4].phychosocialWellbeingGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="phychosocialWellbeingStaffIntervention"
                                    v-model="step[4].phychosocialWellbeingStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[4].phychosocialWellbeingStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[4].phychosocialWellbeingStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 6" title="Health">
                <div class="card-header">
                    <h3 class="card-title">Health</h3>
                </div>
                <div class="card-body">                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Health Conditions</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="healthConditionsNeed"
                                    v-model="step[5].healthConditionsNeed"
                                    :class="{
                                        'is-invalid': v$.step[5].healthConditionsNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].healthConditionsNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="healthConditionsGoalAim"
                                    v-model="step[5].healthConditionsGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[5].healthConditionsGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].healthConditionsGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="healthConditionsStaffIntervention"
                                    v-model="step[5].healthConditionsStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[5].healthConditionsStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].healthConditionsStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Pain</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="painNeed"
                                    v-model="step[5].painNeed"
                                    :class="{
                                        'is-invalid': v$.step[5].painNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].painNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="painGoalAim"
                                    v-model="step[5].painGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[5].painGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].painGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="painStaffIntervention"
                                    v-model="step[5].painStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[5].painStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].painStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Falls</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="fallsNeed"
                                    v-model="step[5].fallsNeed"
                                    :class="{
                                        'is-invalid': v$.step[5].fallsNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].fallsNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="fallsGoalAim"
                                    v-model="step[5].fallsGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[5].fallsGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].fallsGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="fallsStaffIntervention"
                                    v-model="step[5].fallsStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[5].fallsStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].fallsStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Pain and falls assessment</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="painFallsAssessmentNeed"
                                    v-model="step[5].painFallsAssessmentNeed"
                                    :class="{
                                        'is-invalid': v$.step[5].painFallsAssessmentNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].painFallsAssessmentNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="painFallsAssessmentGoalAim"
                                    v-model="step[5].painFallsAssessmentGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[5].painFallsAssessmentGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].painFallsAssessmentGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="painFallsAssessmentStaffIntervention"
                                    v-model="step[5].painFallsAssessmentStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[5].painFallsAssessmentStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[5].painFallsAssessmentStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 7" title="Nutrition">
                <div class="card-header">
                    <h3 class="card-title">Nutrition</h3>
                </div>
                <div class="card-body">                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Nutritional Status / Food and Fluids / Feeding / Complete dietary profile.</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="nutritionalStatusNeed"
                                    v-model="step[6].nutritionalStatusNeed"
                                    :class="{
                                        'is-invalid': v$.step[6].nutritionalStatusNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].nutritionalStatusNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="nutritionalStatusGoalAim"
                                    v-model="step[6].nutritionalStatusGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[6].nutritionalStatusGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].nutritionalStatusGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label mt-3">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="nutritionalStatusStaffIntervention"
                                    v-model="step[6].nutritionalStatusStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[6].nutritionalStatusStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].nutritionalStatusStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Continence/ Elimination, Bladder/Bowel, Toileting regime</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="continenceEliminationNeed"
                                    v-model="step[6].continenceEliminationNeed"
                                    :class="{
                                        'is-invalid': v$.step[6].continenceEliminationNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].continenceEliminationNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="continenceEliminationGoalAim"
                                    v-model="step[6].continenceEliminationGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[6].continenceEliminationGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].continenceEliminationGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="continenceEliminationStaffIntervention"
                                    v-model="step[6].continenceEliminationStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[6].continenceEliminationStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].continenceEliminationStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Night care / Sleeping patterns / Special requirements such as light on, door open or closed, </div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="nightCareNeed"
                                    v-model="step[6].nightCareNeed"
                                    :class="{
                                        'is-invalid': v$.step[6].nightCareNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].nightCareNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="nightCareGoalAim"
                                    v-model="step[6].nightCareGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[6].nightCareGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].nightCareGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label mt-3">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="nightCareStaffIntervention"
                                    v-model="step[6].nightCareStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[6].nightCareStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[6].nightCareStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>

            <div class="card" v-if="currentStep == 8" title="Dental">
                <div class="card-header">
                    <h3 class="card-title">Dental</h3>
                </div>
                <div class="card-body">                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Dental and Oral status / Dentures, Teeth, Oral Condition</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="dentalStatusNeed"
                                    v-model="step[7].dentalStatusNeed"
                                    :class="{
                                        'is-invalid': v$.step[7].dentalStatusNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].dentalStatusNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="dentalStatusGoalAim"
                                    v-model="step[7].dentalStatusGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[7].dentalStatusGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].dentalStatusGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="dentalStatusStaffIntervention"
                                    v-model="step[7].dentalStatusStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[7].dentalStatusStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[7].dentalStatusStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>
            
            <div class="card" v-if="currentStep == 9" title="Skin">
                <div class="card-header">
                    <h3 class="card-title">Skin</h3>
                </div>
                <div class="card-body">                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Skin condition, Skin care/Skin integrity</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="skinConditionNeed"
                                    v-model="step[8].skinConditionNeed"
                                    :class="{
                                        'is-invalid': v$.step[8].skinConditionNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].skinConditionNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="skinConditionGoalAim"
                                    v-model="step[8].skinConditionGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[8].skinConditionGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].skinConditionGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="skinConditionStaffIntervention"
                                    v-model="step[8].skinConditionStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[8].skinConditionStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].skinConditionStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Pressure Area risk</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="pressureAreaNeed"
                                    v-model="step[8].pressureAreaNeed"
                                    :class="{
                                        'is-invalid': v$.step[8].pressureAreaNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].pressureAreaNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="pressureAreaGoalAim"
                                    v-model="step[8].pressureAreaGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[8].pressureAreaGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].pressureAreaGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="pressureAreaStaffIntervention"
                                    v-model="step[8].pressureAreaStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[8].pressureAreaStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].pressureAreaStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Foot problems</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="footProblemsNeed"
                                    v-model="step[8].footProblemsNeed"
                                    :class="{
                                        'is-invalid': v$.step[8].footProblemsNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].footProblemsNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="footProblemsGoalAim"
                                    v-model="step[8].footProblemsGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[8].footProblemsGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].footProblemsGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="footProblemsStaffIntervention"
                                    v-model="step[8].footProblemsStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[8].footProblemsStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].footProblemsStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row gx-5 d-none">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Skin assessment completed</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="skinAssessmentCompletedNeed"
                                    v-model="step[8].skinAssessmentCompletedNeed"
                                    :class="{
                                        'is-invalid': v$.step[8].skinAssessmentCompletedNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].skinAssessmentCompletedNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="skinAssessmentCompletedGoalAim"
                                    v-model="step[8].skinAssessmentCompletedGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[8].skinAssessmentCompletedGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].skinAssessmentCompletedGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="skinAssessmentCompletedStaffIntervention"
                                    v-model="step[8].skinAssessmentCompletedStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[8].skinAssessmentCompletedStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[8].skinAssessmentCompletedStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>
            
            <div class="card" v-if="currentStep == 10" title="Social Involvement">
                <div class="card-header">
                    <h3 class="card-title">Social Involvement</h3>
                </div>
                <div class="card-body">                    
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Activity Pursuit / Activity Preferences and Involvement</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="activityPursuitNeed"
                                    v-model="step[9].activityPursuitNeed"
                                    :class="{
                                        'is-invalid': v$.step[9].activityPursuitNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[9].activityPursuitNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="activityPursuitGoalAim"
                                    v-model="step[9].activityPursuitGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[9].activityPursuitGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[9].activityPursuitGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="activityPursuitStaffIntervention"
                                    v-model="step[9].activityPursuitStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[9].activityPursuitStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[9].activityPursuitStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Social / Spirituality / Religion / Culture</div>
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Need"
                                    value=""
                                    spellcheck="false"
                                    name="socialSpiritualityNeed"
                                    v-model="step[9].socialSpiritualityNeed"
                                    :class="{
                                        'is-invalid': v$.step[9].socialSpiritualityNeed.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[9].socialSpiritualityNeed.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <textarea
                                    rows="4"
                                    class="form-control"
                                    placeholder="Goal / Aim"
                                    value=""
                                    spellcheck="false"
                                    name="socialSpiritualityGoalAim"
                                    v-model="step[9].socialSpiritualityGoalAim"
                                    :class="{
                                        'is-invalid': v$.step[9].socialSpiritualityGoalAim.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[9].socialSpiritualityGoalAim.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">&nbsp;</div>
                                <textarea
                                    rows="8"
                                    class="form-control"
                                    placeholder="Staff Intervention"
                                    value=""
                                    spellcheck="false"
                                    name="socialSpiritualityStaffIntervention"
                                    v-model="step[9].socialSpiritualityStaffIntervention"
                                    :class="{
                                        'is-invalid': v$.step[9].socialSpiritualityStaffIntervention.$invalid,
                                    }"
                                ></textarea>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[9].socialSpiritualityStaffIntervention.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn">Save and continue later</a>
                    </p>                    
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary">Next</a>
                    </p>
                </div>
            </div>
            
            <div class="card" v-if="currentStep == 11" title="RN Signature">
                <div class="card-header">
                    <h3 class="card-title">RN Signature</h3>
                </div>

                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">                            
                                                  
                            <div class="mb-5">
                                <div class="form-label">RN's Signature</div>                     
                                <input
                                    type="text"
                                    class="form-control w-75 mt-2"
                                    name="registeredNurseSignature"
                                    placeholder="Enter your full name"
                                    v-model="step[10].registeredNurseSignature"
                                    :class="{'is-invalid': v$.step[10].registeredNurseSignature.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[10].registeredNurseSignature.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>                         

                        </div>
                        <div class="col-sm-10 col-md-8 col-xl-6">
                        </div>
                    </div>

                </div>
                
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="save-btn" id="last-save-btn">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block back-btn" id="last-back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>
                
            </div>  


        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue, helpers} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import Multiselect from 'vue-multiselect';

// Custom Validators
const isDateFormat = (value) => value.match("^$|((?:[0-9]{2})?[0-9]{2})-(1[0-2]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])") || !helpers.req(value);
const isTextWithSpecialCharacters = (value) => value.match("^[a-zA-Z0-9_ !@#$&%^*()`.+,/\\-\r\n\s\'\"]*$") || !helpers.req(value);
const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ \s\'\"]*$") || !helpers.req(value);

export default {
    name: "carePlanCreateComponent",
    props: ["progressBar", "pageTitle", "residentId", "userId", "carePlan", "operation"], // vue can read kebab props as camel cased vars
    components: { Multiselect },
    setup() {
        return {v$: useVuelidate()};
    },
    data() {

        // If copying, assign carePlan object to a variable
        if (this.operation == 'store') {
            var carePlanObject = {};
        }
        else if (this.operation == 'copy') {
            var carePlanObject = JSON.parse(this.carePlan);
            carePlanObject['long_term_care_plan'] = JSON.parse(carePlanObject['long_term_care_plan']);
            carePlanObject['registered_nurse_signature'] = carePlanObject['registered_nurse_signature'];
        }

        // Return empty string when object doesn't exist 
        // options - array | string
        function returnValueFromObject(fieldName, defaultValue = "", options) {
            // Editing or Copying
            if (!_.isEmpty(carePlanObject)) {
                return carePlanObject['long_term_care_plan'][fieldName] ?? defaultValue;
            } else {
                return defaultValue;
            }
        }


        return {
            currentStep: 1, 
            maxStep: 11,
            percentageComplete: 0,
            errors: 0,
            host: document.location.origin,

            step: [
                // Step 1 - Introduction
                {   
                    overallIntroduction:  returnValueFromObject('overallIntroduction'),
                    medicalDiagnosisNeed: returnValueFromObject('medicalDiagnosisNeed'),
                    medicalDiagnosisGoalAim: returnValueFromObject('medicalDiagnosisGoalAim'),
                    medicalDiagnosisStaffIntervention: returnValueFromObject('medicalDiagnosisStaffIntervention'),
                    relativesNotificationsNeed: returnValueFromObject('relativesNotificationsNeed'),
                    // relativesNotificationsGoalAim: returnValueFromObject('relativesNotificationsGoalAim'),
                    // relativesNotificationsStaffIntervention: returnValueFromObject('relativesNotificationsStaffIntervention'),                   
                },               
                // Step 2 - Activity 
                {   
                    physicalActivitiesNeed: returnValueFromObject('physicalActivitiesNeed'),
                    physicalActivitiesGoalAim: returnValueFromObject('physicalActivitiesGoalAim'),
                    physicalActivitiesStaffIntervention: returnValueFromObject('physicalActivitiesStaffIntervention'),
                    mobilityAidsNeed: returnValueFromObject('mobilityAidsNeed'),
                    mobilityAidsGoalAim: returnValueFromObject('mobilityAidsGoalAim'),
                    mobilityAidsStaffIntervention: returnValueFromObject('mobilityAidsStaffIntervention'),                   
                    functionalStatusNeed: returnValueFromObject('functionalStatusNeed'),
                    functionalStatusGoalAim: returnValueFromObject('functionalStatusGoalAim'),
                    functionalStatusStaffIntervention: returnValueFromObject('functionalStatusStaffIntervention'),                   
                },               
                // Step 3 - Physical 
                {   
                    showeringWashingNeed: returnValueFromObject('showeringWashingNeed'),
                    showeringWashingGoalAim: returnValueFromObject('showeringWashingGoalAim'),
                    showeringWashingStaffIntervention: returnValueFromObject('showeringWashingStaffIntervention'),
                    groomingDressingNeed: returnValueFromObject('groomingDressingNeed'),
                    groomingDressingGoalAim: returnValueFromObject('groomingDressingGoalAim'),
                    groomingDressingStaffIntervention: returnValueFromObject('groomingDressingStaffIntervention'),                   
                    restraintRequirementNeed: returnValueFromObject('restraintRequirementNeed'),
                    restraintRequirementGoalAim: returnValueFromObject('restraintRequirementGoalAim'),
                    restraintRequirementStaffIntervention: returnValueFromObject('restraintRequirementStaffIntervention'),                   
                },               
                // Step 4 - Cognitive 
                {   
                    cognitivePatternsNeed: returnValueFromObject('cognitivePatternsNeed'),
                    cognitivePatternsGoalAim: returnValueFromObject('cognitivePatternsGoalAim'),
                    cognitivePatternsStaffIntervention: returnValueFromObject('cognitivePatternsStaffIntervention'),
                    memoryRecallNeed: returnValueFromObject('memoryRecallNeed'),
                    memoryRecallGoalAim: returnValueFromObject('memoryRecallGoalAim'),
                    memoryRecallStaffIntervention: returnValueFromObject('memoryRecallStaffIntervention'),                   
                    communicationVisionNeed: returnValueFromObject('communicationVisionNeed'),
                    communicationVisionGoalAim: returnValueFromObject('communicationVisionGoalAim'),
                    communicationVisionStaffIntervention: returnValueFromObject('communicationVisionStaffIntervention'),                   
                },               
                // Step 5 - Behaviour 
                {   
                    moodBehaviourNeed: returnValueFromObject('moodBehaviourNeed'),
                    moodBehaviourGoalAim: returnValueFromObject('moodBehaviourGoalAim'),
                    moodBehaviourStaffIntervention: returnValueFromObject('moodBehaviourStaffIntervention'),
                    phychosocialWellbeingNeed: returnValueFromObject('phychosocialWellbeingNeed'),
                    phychosocialWellbeingGoalAim: returnValueFromObject('phychosocialWellbeingGoalAim'),
                    phychosocialWellbeingStaffIntervention: returnValueFromObject('phychosocialWellbeingStaffIntervention'), 
                },  
                // Step 6 - Health 
                {   
                    healthConditionsNeed: returnValueFromObject('healthConditionsNeed'),
                    healthConditionsGoalAim: returnValueFromObject('healthConditionsGoalAim'),
                    healthConditionsStaffIntervention: returnValueFromObject('healthConditionsStaffIntervention'),
                    painNeed: returnValueFromObject('painNeed'),
                    painGoalAim: returnValueFromObject('painGoalAim'),
                    painStaffIntervention: returnValueFromObject('painStaffIntervention'),                   
                    fallsNeed: returnValueFromObject('fallsNeed'),
                    fallsGoalAim: returnValueFromObject('fallsGoalAim'),
                    fallsStaffIntervention: returnValueFromObject('fallsStaffIntervention'),                   
                    painFallsAssessmentNeed: returnValueFromObject('painFallsAssessmentNeed'),
                    painFallsAssessmentGoalAim: returnValueFromObject('painFallsAssessmentGoalAim'),
                    painFallsAssessmentStaffIntervention: returnValueFromObject('painFallsAssessmentStaffIntervention'),                   
                },              
                // Step 7 - Nutrition 
                {   
                    nutritionalStatusNeed: returnValueFromObject('nutritionalStatusNeed'),
                    nutritionalStatusGoalAim: returnValueFromObject('nutritionalStatusGoalAim'),
                    nutritionalStatusStaffIntervention: returnValueFromObject('nutritionalStatusStaffIntervention'),
                    continenceEliminationNeed: returnValueFromObject('continenceEliminationNeed'),
                    continenceEliminationGoalAim: returnValueFromObject('continenceEliminationGoalAim'),
                    continenceEliminationStaffIntervention: returnValueFromObject('continenceEliminationStaffIntervention'),                   
                    nightCareNeed: returnValueFromObject('nightCareNeed'),
                    nightCareGoalAim: returnValueFromObject('nightCareGoalAim'),
                    nightCareStaffIntervention: returnValueFromObject('nightCareStaffIntervention'),                   
                },              
                // Step 8 - Dental 
                {   
                    dentalStatusNeed: returnValueFromObject('dentalStatusNeed'),
                    dentalStatusGoalAim: returnValueFromObject('dentalStatusGoalAim'),
                    dentalStatusStaffIntervention: returnValueFromObject('dentalStatusStaffIntervention'),                                   
                },
                // Step 9 - Skin 
                {   
                    skinConditionNeed: returnValueFromObject('skinConditionNeed'),
                    skinConditionGoalAim: returnValueFromObject('skinConditionGoalAim'),
                    skinConditionStaffIntervention: returnValueFromObject('skinConditionStaffIntervention'),
                    pressureAreaNeed: returnValueFromObject('pressureAreaNeed'),
                    pressureAreaGoalAim: returnValueFromObject('pressureAreaGoalAim'),
                    pressureAreaStaffIntervention: returnValueFromObject('pressureAreaStaffIntervention'),                   
                    footProblemsNeed: returnValueFromObject('footProblemsNeed'),
                    footProblemsGoalAim: returnValueFromObject('footProblemsGoalAim'),
                    footProblemsStaffIntervention: returnValueFromObject('footProblemsStaffIntervention'),                   
                    // skinAssessmentCompletedNeed: returnValueFromObject('skinAssessmentCompletedNeed'),
                    // skinAssessmentCompletedGoalAim: returnValueFromObject('skinAssessmentCompletedGoalAim'),
                    // skinAssessmentCompletedStaffIntervention: returnValueFromObject('skinAssessmentCompletedStaffIntervention'),                   
                },            
                // Step 10 - Social Involvement 
                {   
                    activityPursuitNeed: returnValueFromObject('activityPursuitNeed'),
                    activityPursuitGoalAim: returnValueFromObject('activityPursuitGoalAim'),
                    activityPursuitStaffIntervention: returnValueFromObject('activityPursuitStaffIntervention'),
                    socialSpiritualityNeed: returnValueFromObject('socialSpiritualityNeed'),
                    socialSpiritualityGoalAim: returnValueFromObject('socialSpiritualityGoalAim'),
                    socialSpiritualityStaffIntervention: returnValueFromObject('socialSpiritualityStaffIntervention'),  
                },            
                // Step 11 - RN Signature
                {
                    // createdBy: returnValueFromObject('nightCareStaffIntervention'), // for displaying RN Name
                    registeredNurseSignature: returnValueFromObject('registeredNurseSignature'),
                  
                },
            ],
            api_token: process.env.MIX_API_KEY,
        };
    },
    validations() {
        // TEXT TYPES: default: 191, mid:500, long:1000
        function text(minimum = 3,maximum = 191, isRequired = false, allowSpecial = false) {

            if (allowSpecial) {
                var rule = {
                    required,
                    isTextWithSpecialCharacters,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };
            } else {
                var rule = {
                    required,
                    isTextWithSpace,
                    minLength: minLength(minimum),
                    maxLength: maxLength(maximum),
                    $lazy: true,
                    $autoDirty: true,
                };                
            }

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
                   
            return rule;
        }

        // ARRAY TYPES        
        function inOptions(options, isRequired = false) {
            var rule = {
                required,
                inOptions: inArray(options),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule['required']
            }
            return rule;
        }
        
        // Use for types with no 'required' parameter
        function notRequired(type) {
            var validations = Object.assign({}, type);                
            delete validations['required'];
            
            return validations;
        };

        return {
            step: [
                // Step 1 - Introduction
                {   
                    overallIntroduction: text(3,1500,true,true),
                    medicalDiagnosisNeed: text(3,1500,true,true),
                    medicalDiagnosisGoalAim: text(3,1500,true,true),
                    medicalDiagnosisStaffIntervention: text(3,1500,true,true),
                    relativesNotificationsNeed: text(3,1500,true,true),
                    // relativesNotificationsGoalAim: text(3,1000),
                    // relativesNotificationsStaffIntervention: text(3,1000),                   
                },               
                // Step 2 - Activity 
                {   
                    physicalActivitiesNeed: text(3,1500,true,true),
                    physicalActivitiesGoalAim: text(3,1500,true,true),
                    physicalActivitiesStaffIntervention: text(3,1500,true,true),
                    mobilityAidsNeed: text(3,1500,true,true),
                    mobilityAidsGoalAim: text(3,1500,true,true),
                    mobilityAidsStaffIntervention: text(3,1500,true,true),                   
                    functionalStatusNeed: text(3,1500,true,true),
                    functionalStatusGoalAim: text(3,1500,true,true),
                    functionalStatusStaffIntervention: text(3,1500,true,true),                   
                },               
                // Step 3 - Physical 
                {   
                    showeringWashingNeed: text(3,1500,true,true),
                    showeringWashingGoalAim: text(3,1500,true,true),
                    showeringWashingStaffIntervention: text(3,1500,true,true),
                    groomingDressingNeed: text(3,1500,true,true),
                    groomingDressingGoalAim: text(3,1500,true,true),
                    groomingDressingStaffIntervention: text(3,1500,true,true),                   
                    restraintRequirementNeed: text(3,1500,true,true),
                    restraintRequirementGoalAim: text(3,1500,true,true),
                    restraintRequirementStaffIntervention: text(3,1500,true,true),                   
                },               
                // Step 4 - Cognitive 
                {   
                    cognitivePatternsNeed: text(3,1500,true,true),
                    cognitivePatternsGoalAim: text(3,1500,true,true),
                    cognitivePatternsStaffIntervention: text(3,1500,true,true),
                    memoryRecallNeed: text(3,1500,true,true),
                    memoryRecallGoalAim: text(3,1500,true,true),
                    memoryRecallStaffIntervention: text(3,1500,true,true),                   
                    communicationVisionNeed: text(3,1500,true,true),
                    communicationVisionGoalAim: text(3,1500,true,true),
                    communicationVisionStaffIntervention: text(3,1500,true,true),                   
                },               
                // Step 5 - Behaviour 
                {   
                    moodBehaviourNeed: text(3,1500,true,true),
                    moodBehaviourGoalAim: text(3,1500,true,true),
                    moodBehaviourStaffIntervention: text(3,1500,true,true),
                    phychosocialWellbeingNeed: text(3,1500,true,true),
                    phychosocialWellbeingGoalAim: text(3,1500,true,true),
                    phychosocialWellbeingStaffIntervention: text(3,1500,true,true), 
                },  
                // Step 6 - Health 
                {   
                    healthConditionsNeed: text(3,1500,true,true),
                    healthConditionsGoalAim: text(3,1500,true,true),
                    healthConditionsStaffIntervention: text(3,1500,true,true),
                    painNeed: text(3,1500,true,true),
                    painGoalAim: text(3,1500,true,true),
                    painStaffIntervention: text(3,1500,true,true),                   
                    fallsNeed: text(3,1500,true,true),
                    fallsGoalAim: text(3,1500,true,true),
                    fallsStaffIntervention: text(3,1500,true,true), 
                    painFallsAssessmentNeed: text(3,1500,true,true), 
                    painFallsAssessmentGoalAim: text(3,1500,true,true), 
                    painFallsAssessmentStaffIntervention: text(3,1500,true,true),                                      
                },              
                // Step 7 - Nutrition 
                {   
                    nutritionalStatusNeed: text(3,1500,true,true),
                    nutritionalStatusGoalAim: text(3,1500,true,true),
                    nutritionalStatusStaffIntervention: text(3,1500,true,true),
                    continenceEliminationNeed: text(3,1500,true,true),
                    continenceEliminationGoalAim: text(3,1500,true,true),
                    continenceEliminationStaffIntervention: text(3,1500,true,true),                   
                    nightCareNeed: text(3,1500,true,true),
                    nightCareGoalAim: text(3,1500,true,true),
                    nightCareStaffIntervention: text(3,1500,true,true),                   
                },              
                // Step 8 - Dental 
                {   
                    dentalStatusNeed: text(3,1500,true,true),
                    dentalStatusGoalAim: text(3,1500,true,true),
                    dentalStatusStaffIntervention: text(3,1500,true,true),                                   
                },
                // Step 9 - Skin 
                {   
                    skinConditionNeed: text(3,1500,true,true),
                    skinConditionGoalAim: text(3,1500,true,true),
                    skinConditionStaffIntervention: text(3,1500,true,true),
                    pressureAreaNeed: text(3,1500,true,true),
                    pressureAreaGoalAim: text(3,1500,true,true),
                    pressureAreaStaffIntervention: text(3,1500,true,true),                   
                    footProblemsNeed: text(3,1500,true,true),
                    footProblemsGoalAim: text(3,1500,true,true),
                    footProblemsStaffIntervention: text(3,1500,true,true),                   
                    // skinAssessmentCompletedNeed: text(3,1500,false,true),
                    // skinAssessmentCompletedGoalAim: text(3,1500,false,true),
                    // skinAssessmentCompletedStaffIntervention: text(3,1500,false,true), 
                },            
                // Step 10 - Social Involvement 
                {   
                    activityPursuitNeed: text(3,1500,true,true),
                    activityPursuitGoalAim: text(3,1500,true,true),
                    activityPursuitStaffIntervention: text(3,1500,true,true),
                    socialSpiritualityNeed: text(3,1500,true,true),
                    socialSpiritualityGoalAim: text(3,1500,true,true),
                    socialSpiritualityStaffIntervention: text(3,1500,true,true),  
                },            
                // Step 11 - RN Signature
                {
                    registeredNurseSignature: text(3,191,true),
                },               
            ],
        };
    },

    computed: {},

    methods: {
        onClickNext: function () {            

            // Validate fields on current step
            this.v$.step[this.currentStep - 1].$touch();
            console.log('clicked next' + this.currentStep-1 + this.v$.step[this.currentStep - 1].$error );
            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep - 1].$error) {
                // All steps
                if (this.currentStep < this.maxStep) {
                    // Proceed to next step
                    this.currentStep++;

                // Final step
                } else if (this.currentStep == this.maxStep) {
                    // Initialize alerts and toast notifications for displaying message  
                    const toastError = Swal.mixin({          
                            toast: true,                
                            position: 'top-end', 
                            showConfirmButton: true, 
                        });  
                    const alertSuccess = Swal.mixin({                          
                            position: 'center', 
                            showConfirmButton: true, 
                            timer: 3000,
                            timerProgressBar: true,
                        });
                        

                    // Set variables for server side validation                                                       
                    const endpoint = location.protocol + "//" + window.location.host + "/api/care-plans/"  + process.env.MIX_API_KEY; 
                   

                    // Show button spinner
                    document.getElementById('submit-btn').innerHTML  = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById('submit-btn').disabled  = true;
                    document.getElementById('last-back-btn').setAttribute('style', 'display:none !important');
                    document.getElementById('last-save-btn').setAttribute('style', 'display:none !important');

                    // Loop through all fields
                    const formData = {};
                    
                    for(let i=0; i < this.maxStep; i++){
                        for ( const [key,value] of Object.entries( this.step[i] ) ) {
                            // formData.append(key, value);
                            formData[key] = value;                     
                        }
                    }

                    // Add residentID and userID
                    formData['residentID'] = this.residentId;
                    formData['userID'] = this.userId;
                    formData['type'] = "Long Term";
                    
                    // Call the store endpoint
                    axios.post(endpoint, formData)
                        .then((response) => {
                            if(response.data.error == 403){                                
                                console.log('Bad Request');
                                console.log(response.data);
                                
                                // Show bad request toast message. This error occurs when the input fields are not in the expected format
                                toastError.fire({ 
                                    type: 'warning', 
                                    title: 'The input fields are malformed and cant be processed.' 
                                }); 
                            } else {
                                if(response.data.id == null){
                                    console.log('Validation Error');
                                    console.log(response.data);
                                    
                                    // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the resident object
                                    toastError.fire({ 
                                        type: 'warning', 
                                        title: 'There are validation errors found on the form.'
                                    }); 
                                    
                                }
                                else{
                                    console.log("Success");
                                    console.log(response.data);

                                     // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the resident object was added to the DB. Thi
                                    this.formSuccess = true;
                                    window.residentId = this.residentId; 

                                    alertSuccess.fire({
                                        title: "Success!",
                                        text: "The long term care plan has been added.",
                                        icon: "success",                           
                                    }).then(function(){
                                        window.location = "/residents/"+window.residentId+"/care-plans?type=Long+Term";
                                    }); 
                                }
                            }                                        
                           
                        })
                        .catch((err) => {                            
                            console.log("Endpoint Error!");
                            console.log(err.response);
                            toastError.fire({ type: 'warning', title: 'Sorry, request failed to submit.' }); // this error occurs when endpoint is wrong
                        })
                }
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
            }
        },
        onClickBack: function () {
            if (this.currentStep > 1) {
                this.currentStep--;
            }
            this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
        },
        
    },
};
</script>
